import React from "react";
import {
  MenuTrigger as SpectrumMenuTrigger,
  type MenuTriggerProps,
} from "@react-spectrum/s2";

const Spectrum = SpectrumMenuTrigger as React.FC<MenuTriggerProps>;

/** S2 types `MenuTrigger` as returning `ReactNode` (TS2786 under @types/react 18). */
export function MenuTrigger(props: MenuTriggerProps) {
  return <Spectrum {...props} />;
}

export type { MenuTriggerProps };
